import {
  bulandiGroupEventTeammateSlots,
  bulandiIsGroupEventForRegistration,
} from "../data/bulandiGroupEventRegistration";
import {
  bulandiEventSheetHeader,
  findRegistrationRowByBrNumber,
  findSheetColumnKeyForEventName,
  getRegistrationDobFromRow,
  parseBulandiSheetEventCellBrNumbers,
} from "./bulandiRegistrationSheet";

/**
 * Teammate defaults from a sheet row for pre-selected group events (B No. and DOB when found in sheet).
 */
export function buildGroupTeammateDefaultsFromRow(
  row,
  headers,
  eligibleEvents,
  preselectedIdSet,
  participantBrNumeric,
  allRows = [],
) {
  const out = {};
  if (participantBrNumeric == null || !Number.isFinite(participantBrNumeric))
    return out;
  for (const ev of eligibleEvents) {
    if (!bulandiIsGroupEventForRegistration(ev.id)) continue;
    if (!preselectedIdSet.has(ev.id)) continue;
    const key = findSheetColumnKeyForEventName(headers, bulandiEventSheetHeader(ev));
    if (!key) continue;
    const nums = parseBulandiSheetEventCellBrNumbers(row[key]);
    const mates = nums.filter((n) => n !== participantBrNumeric);
    const slots = bulandiGroupEventTeammateSlots(ev.id);
    const arr = [];
    for (let i = 0; i < slots; i += 1) {
      const n = mates[i];
      if (n == null) {
        arr.push({ br: "", dob: "" });
        continue;
      }
      const br = `B${n}`;
      const mateMatch = findRegistrationRowByBrNumber(allRows, headers, br);
      const dob = mateMatch ? getRegistrationDobFromRow(mateMatch.row, headers) : "";
      arr.push({ br, dob });
    }
    out[ev.id] = arr;
  }
  return out;
}
